if(location.hash && location.hash === '#submenu'){
  $('.product-cart-lists .product-cart__tags .tags .tag').addClass('shrink')
  $(window).on('load', function(){
    $('body').addClass('ready')
  })
}else{
  $('body').addClass('ready')
}


function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");
    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");

        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });

    jQuery(".paralax-insta:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;

      if (meTop > limitTop && meBottom < limitBottom) {
        for (var i = 1; i <= 8; i++) {
          me.find(".paralax__image.image-" + i).addClass(" animated myAnimation_" + i);
        }
        for (var i = 1; i <= 10; i++) {
          me.find(".paralax__title.title-" + i).addClass(" animated titleAnimation_" + i);
        }
        me.find(".paralax__image-logo.image-7").addClass(" animated myAnimation_7");
        me.find(".paralax__image-logo.image-8").addClass(" animated myAnimation_8");
        setTimeout(function () {
          // me.removeClass("animated wowo");
        }, 5000);
      }
    });
  }, 100);
}

// function scroll() {
//   jQuery(window).scroll(function () {
//     var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     var ele_height = jQuery(".header").innerHeight();

//     if (scrollTop > ele_height) {
//       jQuery("header").addClass("sticky");
//     } else {
//       jQuery("header").removeClass("sticky");
//     }

//     if (jQuery(".breadcrumb").length > 0) {
//       var pageTitle_t = jQuery(".page__title").offset().top;

//       var breadcrumb_t = jQuery(".page__title").innerHeight() + pageTitle_t - ele_height;

//       if (scrollTop > breadcrumb_t) {
//         jQuery(".breadcrumb").addClass("fixed").css("top", ele_height);
//       } else {
//         jQuery(".breadcrumb").removeClass("fixed");
//       }
//     }
//   });
// }

function cookie() {
  if (jQuery(".email-open").length > 0) {
    if (jQuery.cookie("open-pop-up")) {
      jQuery(".email-open").removeClass("active");
    } else {
      jQuery(".email-open").addClass("active");
    }
    jQuery.cookie("open-pop-up", "email-open", {
      expires: 60,
      path: "/",
    });

    $(".email-open .icon-close").click(function () {
      jQuery(".email-open").removeClass("active");
    });
  }
}

function video() {
  jQuery(".video-link.mp4,.is-video").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });

    var video_url = jQuery(this).find(".data-video").html();
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"></video>');
    jQuery(".video-light-box").fadeIn(300);

    var videoElements = jQuery(".video-light-box video");
    var hls = new Hls();
    videoElements.each(function () {
      var videoSrc = jQuery(this).find("source").attr("src");
      var videoElement = this;
      if (videoSrc.endsWith(".mp4")) {
      } else {
        hls.loadSource(videoSrc);
        hls.attachMedia(videoElement);
      }
    });
  });
  jQuery(".video-link.file").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    var video_url = jQuery(this).find(".data-video").html();
    var caption = jQuery(this).find(".data-video").attr("data-caption");
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"> <track src="' + caption + '"  srclang="en" label="English" kind="subtitles" default /></video>');
    jQuery(".video-light-box").fadeIn(300);
  });
  jQuery(".video-link.embed").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    jQuery(".video-light-box").fadeIn(300);
    var html = jQuery(this).find(".data-video").html();
    jQuery(".video-light-box").find(".play-iframe-video").html(html);
  });

  jQuery(".video-light-box .icon-close").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });

  jQuery(".video-light-box").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });
  jQuery(".video-light-box .video-box").click(function (event) {
    event.stopPropagation();
  });

  jQuery(".video-link,.is-video").click(function (event) {
    event.stopPropagation();
    var vvv = jQuery(this).children(".video").find("video");
    vvv.on("loadedmetadata", function () {
      vvv.trigger("play");
    });
    // vvv.trigger('play');

    setTimeout(function () {
      var ss = jQuery(".video-light-box .video-box video");
      ss.trigger("play");
    }, 300);
  });

  jQuery(".video-show").click(function (event) {
    event.stopPropagation();
    jQuery(this).children(".text-and-img").addClass("is-active");
    var vvv = jQuery(this).parents(".video").find("video");

    if (jQuery(this).hasClass("is-active")) {
      vvv.trigger("play");
      jQuery(this).removeClass("is-active");
    } else {
      jQuery(this).addClass("is-active");
      vvv.trigger("pause");
    }
  });
}

function hlsVideo() {
  // var videoElements = document.querySelectorAll("video");

  var videoElements = document.querySelectorAll("video");

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute("src");

    if (videoSrc && videoSrc.endsWith(".mp4")) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function insta() {
  if (jQuery("#instafeed").length > 0) {
    var InstagramToken = $("#instafeed").attr("data-key");
    var link = $("#instafeed").attr("data-link");
    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: 6,
      template: '<div class="paralax__image ">  <div style="background-image:  url({{image}})"></div></div>',
      after: function () {
        jQuery(".paralax__image").each(function () {
          var i = jQuery(this).index() + 1;
          jQuery(this).addClass(" image-" + i + "");
        });

        wowo();
      },
    });
    feed.run();
  }
}

function resizeWindow() {
  var header_h = jQuery(".header").innerHeight();
  var header__top_bar_h = jQuery(".header__top-bar").innerHeight() || 0;
  var window_h = jQuery(window).height();
  //$("#MainContent").css("padding-top", header_h);
  //$(".header").css("top", (-header__top_bar_h + 'px'));

  if ($(window).width() < 1200) {
    var swiperW = parseFloat($("#swiper2 .swiper-pagination").width());
    $(".quote-swiper .swiper-button-prev").css("margin-right", swiperW / 2 + 13.5 + "px");
    $(".quote-swiper .swiper-button-next").css("margin-left", swiperW / 2 + 13.5 + "px");

    var slickW = parseFloat($(".gallery-swiper .slick-dots").width());
    $(".gallery-swiper .slick-left").css("margin-right", slickW + 30 + "px");
    $(".gallery-swiper .slick-right").css("margin-left", slickW + 30 + "px");
  } else {
    $(".quote-swiper .swiper-button-prev").css("margin-right", "0");
    $(".quote-swiper .swiper-button-next").css("margin-left", "0");
  }

  if($(window).width() < 991) {
    $('.side-cart').css('height',window_h)
  } else {
    $('.side-cart').css('height',window_h - header_h)
  }
  jQuery(window).resize(function () {
    var header_h = jQuery(".header").innerHeight();
    var header__top_bar_h = jQuery(".header__top-bar").innerHeight() || 0;
    var window_h = jQuery(window).height();
    if($(window).width() < 991) {
      $('.side-cart').css('height',window_h)
    } else {
      $('.side-cart').css('height',window_h - header_h)
      //$('.side-cart').css('height',window_h - header__top_bar_h)
    }
    //$("#MainContent").css("padding-top", header_h);
   //$(".header").css("top", (-header__top_bar_h + 'px'));
    if ($(window).width() < 1200) {
      var swiperW = parseFloat($("#swiper2 .swiper-pagination").width());
      $(".quote-swiper .swiper-button-prev").css("margin-right", swiperW / 2 + 13.5 + "px");
      $(".quote-swiper .swiper-button-next").css("margin-left", swiperW / 2 + 13.5 + "px");
      var slickW = parseFloat($(".gallery-swiper .slick-dots").width());
      $(".gallery-swiper .slick-left").css("margin-right", slickW + 30 + "px");
      $(".gallery-swiper .slick-right").css("margin-left", slickW + 30 + "px");
    } else {
      $(".quote-swiper .swiper-button-prev").css("margin-right", "0");
      $(".quote-swiper .swiper-button-next").css("margin-left", "0");

      $(".gallery-swiper .slick-left").css("margin-right", "0");
      $(".gallery-swiper .slick-right").css("margin-left", "0");
    }
  });
  $(window).scroll(function () {
    var header_h = jQuery(".header").innerHeight();
    var header__top_bar_h = jQuery(".header__top-bar").innerHeight() || 0;
    //$("#MainContent").css("padding-top", header_h);
    //$(".header").css("top", (-header__top_bar_h + 'px'));
    if ($(window).width() < 1200) {
      var swiperW = parseFloat($("#swiper2 .swiper-pagination").width());
      $(".quote-swiper .swiper-button-prev").css("margin-right", swiperW / 2 + 13.5 + "px");
      $(".quote-swiper .swiper-button-next").css("margin-left", swiperW / 2 + 13.5 + "px");
      var slickW = parseFloat($(".gallery-swiper .slick-dots").width());
      $(".gallery-swiper .slick-left").css("margin-right", slickW + 30 + "px");
      $(".gallery-swiper .slick-right").css("margin-left", slickW + 30 + "px");
    } else {
      $(".quote-swiper .swiper-button-prev").css("margin-right", "0");
      $(".quote-swiper .swiper-button-next").css("margin-left", "0");

      $(".gallery-swiper .slick-left").css("margin-right", "0");
      $(".gallery-swiper .slick-right").css("margin-left", "0");
    }
  });


}

function parallax() {
  var sh = jQuery(window).scrollTop();
  var wh_ha = jQuery(window).height() / 3;

  jQuery(".parallax").each(function () {
    var parallax_h = jQuery(this).offset().top;
    if (sh > parallax_h - wh_ha) {
      var parallax_y = (sh - (parallax_h - wh_ha)) / 8;
      jQuery(this).css("transform", "translate3d(0px,-" + parallax_y + "px, 0px)");
    }
  });
}

function hoverSwitch() {
  $(".collection-items .item").each(function () {
    var $this = $(this);
    $this.find(".color-swatch .img").eq(0).addClass("active");
    $this.find(".switch-color .color").eq(0).addClass("active");

    if ($this.find(".switch-color .color").length > 5) {
      $this.find(".more-s").show();
    } else {
      $this.find(".more-s").hide();
    }
    $('.more-s').click(function (e) {
      e.stopPropagation();
    })
    giveMore($this.find(".more-s"), $this.find(".switch-color-box"), 5, 600);

  });

  $('.product-info__details-colors .color').on('mouseenter', function () {
      var color = $(this).data('color');
      var collection = $(this).data('collection');
      if(color){
        $('[data-collection-color]').text(color)
      }

      if(collection){
        $('.img-prime-additional[data-collection="'+collection+'"]').fadeIn(300).siblings('.img-prime-additional').fadeOut();
      }
  }).on('mouseleave', function () {
      var color = $('[data-collection-color]').data('collection-color');
      if(color){
        $('[data-collection-color]').text(color)
      }
      $('.img-prime-additional').fadeOut();
  })

  // $(document).on("mouseenter touchstart", ".switch-color-box .color", function (e) {
  //   e.preventDefault();
  //   var index = $(this).index();
  //   var $item = $(this).closest(".item");
  //   $(this).addClass("active").siblings().removeClass("active");
  //   $item.find(".color-swatch .img").eq(index).addClass("active").siblings().removeClass("active");
  // });

  // $(document).on("mouseenter touchstart", ".colors .color", function (e) {
  //   e.preventDefault();
  //   var index = $(this).index();
  //   $(this).addClass("active").siblings().removeClass("active");
  //   $(this).parents(".card-body").siblings(".card-images").find(".image-colors img").eq(index).addClass("active").siblings().removeClass("active");
  //   $(this).parents(".card-body").siblings(".card-images").find(".imgs .img").eq(index).addClass("active").siblings().removeClass("active");
  // });

  function giveMore(button, targetUl, showNumber, speed) {
    var list = showNumber;
    var row = $(targetUl);
    var sum = row.find(".color").hide().length;

    if (sum > list) {+
      row.find(".color:lt(" + list + ")").show();
    } else {
      row.find(".color:lt(" + list + ")").show();
    }

    $(button).on("click", function () {
      list += sum;
      row.find(".color:lt(" + list + ")").slideDown(speed);
    });
  }
}

function swiper() {
  var swiper1 = new Swiper("#swiper1", {
    slidesPerView: "4",
    speed: 500,

    grabCursor: true,
    spaceBetween: 16,
    navigation: {
      prevEl: " .popular-styles .swiper-button-prev",
      nextEl: ".popular-styles .swiper-button-next",
    },
    breakpoints: {
      1400: {
        slidesPerView: "4",
      },
      991: {
        slidesPerView: "3",
      },
      768: {
        slidesPerView: "2",
        centeredSlides: false,
        centerInsufficientSlides: false,
        loop: false,
      },
      575: {
        slidesPerView: "1",
        slidesPerView: "1.31",
        centeredSlides: true,
        centerInsufficientSlides: true,
        loop: true,
      },
      200: {
        slidesPerView: "1.31",
        centeredSlides: true,
        centerInsufficientSlides: true,
        loop: true,
        spaceBetween: 13,
      },
    },
  });

  var swiper2 = new Swiper("#swiper2", {
    slidesPerView: "3",
    speed: 500,
    grabCursor: true,
    spaceBetween: 24,
    slidesPerGroup: 3,
    // loop:true,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".quote-swiper .swiper-button-prev",
      nextEl: ".quote-swiper .swiper-button-next",
    },
    breakpoints: {
      991: {
        slidesPerView: "3",
      },
      768: {
        slidesPerView: "2",
        slidesPerGroup: 2,
      },
      575: {
        slidesPerView: "1",
        slidesPerGroup: 1,
        spaceBetween: 24,
      },
      200: {
        slidesPerView: "1.36",
        centeredSlides: true,
        centerInsufficientSlides: true,
        loop: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
      },
    },
  });

  var swiper3 = new Swiper("#swiper3", {
    speed: 500,
    grabCursor: true,

    slidesPerView: "auto",
    spaceBetween: 20,

    breakpoints: {
      1200: {
        // slidesPerView: "1.83",
      },
      768: {
        spaceBetween: 20,
        centeredSlides: false,
        centerInsufficientSlides: false,
      },
      320: {
        spaceBetween: 16,
        centeredSlides: true,
        centerInsufficientSlides: true,
      },
    },

    navigation: {
      prevEl: ".reviews-swiper .swiper-button-prev",
      nextEl: ".reviews-swiper .swiper-button-next",
    },
  });
  var swiper4 = new Swiper("#swiper4", {
    slidesPerView: "1",
    speed: 500,
    grabCursor: true,
    // centeredSlides: true,
    // centerInsufficientSlides: true,
    setWrapperSize: true,
    loop: true,
    spaceBetween: 10,
    // loopedSlides: 3,
    slidesPerView: 3,
    slidesPerGroup: 1,
    initialSlide: 0,
    centeredSlides: true,
    loopAdditionalSlides: 1,
    navigation: {
      prevEl: ".gallery-swiper .swiper-button-prev",
      nextEl: ".gallery-swiper .swiper-button-next",
    },
  });
// Get the number of slides
var slideCount = document.querySelectorAll("#swiper5 .swiper-slide").length;

// Determine if the loop should be enabled
var shouldLoop = slideCount >= 3;

// Initialize Swiper with conditional loop
var swiper5 = new Swiper("#swiper5", {
  slidesPerView: "3",
  speed: 500,
  loop: shouldLoop,
  spaceBetween: 50,
  breakpoints: {
    991: {
      slidesPerView: "3",
    },
    768: {
      centeredSlides: false,
      centerInsufficientSlides: false,
    },
    575: {
      slidesPerView: "2",
      centeredSlides: false,
      centerInsufficientSlides: false,
      spaceBetween: 16,
    },
    200: {
      slidesPerView: "1",
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 16,
      loopAdditionalSlides: 1,
    },
  },
});

  var swiper7 = new Swiper("#swiper7", {
    spaceBetween: 7,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiper6 = new Swiper("#swiper6", {
    spaceBetween: 10,

    loop: true,
    navigation: {
      prevEl: ".product-info__images .swiper-button-prev",
      nextEl: ".product-info__images .swiper-button-next",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: swiper7,
    },
  });
  var swiper8 = new Swiper("#swiper8", {
    slidesPerView: 1,
    speed: 500,
    grabCursor: true,
    centeredSlides: true,
    centerInsufficientSlides: true,
    loop: true,
    spaceBetween: 26,
    loopAdditionalSlides: 2,
    
    breakpoints: {
      575: {
        spaceBetween: 26,
      },

      200: {
        spaceBetween: 11,
      },
    },
    navigation: {
      prevEl: ".mask-swiper .swiper-button-prev",
      nextEl: ".mask-swiper .swiper-button-next",
    },
  });
  $('.mask-swiper .swiper-box').append('<div class="swiperLeft"></div>');
  $('.mask-swiper .swiper-box').append('<div class="swiperRight"></div>');

$('.mask-swiper .swiperLeft').click(function () {
    $('.mask-swiper .swiper-button-prev').trigger('click');
})
$('.mask-swiper .swiperRight').click(function () {
    $('.mask-swiper .swiper-button-next').trigger('click');
})
  if ($(".slick-content").length > 0) {
    $('.slick-content:not(".slick-initialized")').slick({
      slidesToScroll: 1,
      infinite: true,
      slidesToShow: 1,
      arrows: true,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,
      slidesToScroll: 1,
      variableWidth: true,
      swipeToSlide: true,
      nextArrow: ".slick-buttons .slick-next",
      prevArrow: ".slick-buttons .slick-left",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });
  }
}
function click() {
  // Gallery Images
  // $(".gallery-swiper .slick-image .icon-plus").click(function (e) {
  //   var index = $(this).parent().attr("data-slick-index");

  //   $(".image-light-box").addClass("active");
  //   $(".image-light-box .img").eq(index).addClass("active").siblings().removeClass("active");
  //   e.stopPropagation();
  // });
  // $(".mask-swiper .icon-plus").click(function (e) {
  //   var index = $(this).parent().attr("data-swiper-slide-index");

  //   $(".image-light-box").addClass("active");
  //   $(".image-light-box .img").eq(index).addClass("active").siblings().removeClass("active");
  //   e.stopPropagation();
  // });
  $(".image-light-box .icon-close").click(function () {
    $(".image-light-box").removeClass("active");
  });

  // Product Images
  // $(".product-info__details-accordion .light-box").click(function (e) {
  //   $(".product-info__accordion-light-box").addClass("active");
  //   e.stopPropagation();
  // });
  // $(".product-info__accordion-light-box .icon-close").click(function () {
  //   $(".product-info__accordion-light-box").removeClass("active");
  // });

  // Swiper
  // $("#swiper6 .swiper-slide.image-slide").click(function (e) {
  //   var index = $(this).index();
  //   $(".product-info__images-light-box").addClass("active");
  //   $(".product-info__images-light-box .img").eq(index).addClass("active").siblings().removeClass("active");
  //   e.stopPropagation();
  // });
  $("#swiper6 .swiper-slide.video-slide .play").click(function (e) {
    $(this).parent().find('video')[0].play()
    $(this).parent().find('video').attr('controls', true)
    $(this).fadeOut()
    e.stopPropagation();
  });
  // $("#swiper8 .swiper-slide .image").click(function (e) {
  //   var index = $(this).parent().attr("data-swiper-slide-index");

  //   $(".mask-swiper .image-light-box").addClass("active");
  //   $(".mask-swiper .image-light-box .img").eq(index).addClass("active").siblings().removeClass("active");
  //   e.stopPropagation();
  // });

  // Nav
  $(".header__burger").click(function () {
    $(this).addClass("active");
    $(".header__navigation-show-m").addClass("active");
    $("html,body").addClass("overflow_hidden");
  });

  $(".product-info__images-light-box .icon-close").click(function () {
    $(".product-info__images-light-box").removeClass("active");
  });

  $(".header__navigation-show-m .icon-close").click(function () {
    $(".header__navigation-show-m").removeClass("active");
    $(".header__burger").removeClass("active");
    $("html,body").removeClass("overflow_hidden");

  });
  $(".video-and-image .image").click(function (e) {
    $(".video-and-image .image-light-box").addClass("active");
    $(".video-and-image .image-light-box .img").eq(0).addClass("active").siblings().removeClass("active");
    e.stopPropagation();
  });

  $(".header__navigation-show-m .menu-item-has-children > a").click(function () {
    $(this).parent().toggleClass("active").find(".menu-item-children-box").stop().slideToggle().parent().siblings().removeClass("active").find(".menu-item-children-box").slideUp();
  });
  // FAQ
  $(".faq-item h3").click(function () {
    var $this = $(this);
    $(this).parent().toggleClass("active").siblings().removeClass("active").find(".faq-item-box").slideUp(300);
    $(this).siblings(".faq-item-box").stop().slideToggle(300, function(){
      var self = this;
      if($(window).scrollTop() > $this.offset().top){
        setTimeout(function() {
            theOffset = $(self).offset();
            console.log(theOffset.top)
            $('body,html').animate({ scrollTop: theOffset.top - $('header').outerHeight() * 2 });
        }, 10);
      }
    });

    
   
    // $this.parent().siblings().find("h3").removeClass("active").siblings().slideUp();
    // $this.toggleClass("active").siblings().stop().slideToggle(function() {
    //   var self = this;
    //   if($(window).scrollTop() > $this.offset().top){
    //     setTimeout(function() {
    //         theOffset = $(self).offset();
    //         console.log(theOffset.top)
    //         $('body,html').animate({ scrollTop: theOffset.top - $('header').outerHeight() * 2 });
    //     }, 10);
    //   }
    // })
  });

  // Filter
  $(".filter__sorts-item  .item-title").click(function () {
    $(this).toggleClass("active").siblings().stop().slideToggle(300);
    $(this).parent().siblings().find(".item-title").removeClass("active").siblings().slideUp(300);
  });
  $(".filter-btn").click(function () {
    $(".filter__sorts").addClass("active");
  });
  $(".filter__sorts-title .icon-close").click(function () {
    $(".filter__sorts").removeClass("active");
  });
  $('.filer__sorts-btn .btn-grey').click(function () {
    $(".filter__sorts").removeClass("active");
  })

  // Option Select
  $(".option-select .select-input").click(function () {
    $(this).toggleClass("active").siblings().slideToggle();
    $(this).parents(".option").siblings().find(".select-input").removeClass("active").siblings().slideUp();
  });

  $(".option-select ul li").click(function () {
    var text = $(this).find("span").html().trim();
    var value = $(this).find("span").data('value');
    $(this).parent().slideUp().parents(".option-select").find(".select-input").removeClass("active").find("span").html(text).data('value', value);
  });
  //   Product List
  $(".product-cart__lists .list h3").each(function (index) {
    var html = $(this)
      .html()
      .replace(/[^\w]|_/g, "");

    // $(this).attr("id", html);
    // var linkElements = $(".quick-links .quicklink");
    // var $navLink = linkElements.eq(index);
    // $navLink.attr("href", "#" + html);
  });
  $(".quicklink").click(function () {
    var eleHeight = $(".product-cart__tags").innerHeight();
    var headerHeight = $(".header").innerHeight();
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - headerHeight - eleHeight  - 24 }, 800);
  });
  // Scroll Top
  $(".scroll-top .icon-arrow-up").click(function () {
    $("html,body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });
  //  Search box
  $(".header__icon--search").click(function () {
    $(".search-modal").addClass("active");
  });
  $(".search-modal__close-button").click(function () {
    $(".search-modal").removeClass("active");
  });
  // Accordion
  $(".product-info__details-accordion .item h3").click(function () {
    var $this = $(this);
   
    $this.parent().siblings().find("h3").removeClass("active").siblings().slideUp();
    $this.toggleClass("active").siblings().stop().slideToggle(function() {
      var self = this;
      if($(window).scrollTop() > $this.offset().top){
        setTimeout(function() {
            theOffset = $(self).offset();
            console.log(theOffset.top)
            $('body,html').animate({ scrollTop: theOffset.top - $('header').outerHeight() * 2 });
        }, 10);
      }
    })

    //$this[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  });

  // Product Tags
  $(".product-cart__tags .tag").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
  });

  // Side Cart
  
  $(".cart-side-open .open-btn").click(function () {
    $(".side-cart").addClass("active");
  });
  $(".side-cart .icon-close").click(function () {
    $(".side-cart").removeClass("active");
  });
  $(".view-all-links").click(function () {
    $(this).toggleClass("active").siblings(".product-cart__quick-links").stop().slideToggle();
  });

  //  Form Toggle
  $(".contact-form .forgot-password").click(function () {
    $(".contact-form.login .container").addClass("active");
  });
  $(".contact-form .back").click(function () {
    $(".contact-form.login .container").removeClass("active");
  });

  $('[data-assembly-quicklink]').click(function (e) {
    e.preventDefault()
    var videoLink = $(this).attr('href');
    var videoTop =   $('.assembly-videos').scrollTop() + ($(videoLink).offset().top - $(videoLink).parent().offset().top);
    console.log(videoTop)
    $('.assembly-videos').animate({scrollTop:videoTop})
  })

  function validateEmail(email) {
    var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }

  function validateInput(input) {
    var value = input.val().trim();
    var isValid = true;

    if (input.attr("type") === "email") {
      isValid = validateEmail(value);
    } else {
      isValid = value !== "";
    }

    if (isValid) {
      input.parent().removeClass("errors");
    } else {
      input.parent().addClass("errors");
    }

    return isValid;
  }

  function copyFormData($form) {
    const formData = {
      name: $form.find('[data-name="name"]').val(),
      phone: $form.find('[data-name="phone"]').val(),
      email: $form.find('[data-name="email"]').val(),
      message: $form.find('[data-name="message"]').val(),
      // utm_source: $form.find('[data-name="utm_source"]').val(),
      // utm_medium: $form.find('[data-name="utm_medium"]').val(),
      // utm_campaign: $form.find('[data-name="utm_campaign"]').val(),
      // utm_content: $form.find('[data-name="utm_content"]').val(),
      // utm_term: $form.find('[data-name="utm_term"]').val(),
      // gclid: $form.find('[data-name="gclid"]').val(),
      // fbclid: $form.find('[data-name="fbclid"]').val(),
      // token: $form.find('[data-name="token"]').val()
    };
  
    Object.keys(formData).forEach((key) => {
      $('[data-design-form] [data-name="'+key+'"]').val(formData[key]);
    });
    $('.form-field-name').text(formData.name);
  }

  $(".free-kitchen-design form, .form-sec form").on('submit', function (e) {
    
    e.preventDefault();
    $('html, body').addClass('overflow_hidden');
    var hasError = false;

    $(this).find(".required-field input").each(function () {
        if (!validateInput($(this))) {
          hasError = true;
        }
      });

    copyFormData($(this).find(".form-input"));
    if (!hasError) {
      $(".kitchen-design-light-box").addClass("active");
    

        var formElement = $(this)[0];
        var formData = new FormData(formElement);
        var request = new XMLHttpRequest();
        
        // Add event listener for when the request is completed
        request.addEventListener("load", function () {
          if (request.status >= 200 && request.status < 400) {          
             gtag_report_conversion();
             fbq('track', 'Lead');
          } else {
      
          }
        });
      
        // Add event listener for when the request encounters an error
        request.addEventListener("error", function () {
          console.error("An error occurred while submitting the form:", request.statusText);
        });
      
        request.open("POST", formElement.action);
        request.send(formData);
      } else {
        $(".kitchen-design-light-box").removeClass("active");
      }
  });

  $('[data-design-form-link]').click(function(e){
    $('[data-design-form-link]').find('.loading__spinner').removeClass('hidden');
    $(this).next().submit();
    e.preventDefault()
  })
  $('[data-design-form]').submit(function(e){

      var formElement = this;
      var formData = new FormData(formElement);
      var request = new XMLHttpRequest();
    
      // Add event listener for when the request is completed
      $(formElement).find('button').attr('disabled', 'disabled');
      $(formElement).find('.loading__spinner').removeClass('hidden');
      request.addEventListener("load", function () {
        $(formElement).find('.loading__spinner').addClass('hidden');
        $(formElement).find('button').attr('disabled', false);
        $('[data-design-form-link]').find('.loading__spinner').addClass('hidden');
        if (request.status >= 200 && request.status < 400) {

          $(formElement).hide().next().show();
          gtag_report_conversion();
          fbq('track', 'Lead');
          
        
        } else {
    
        }
      });
    
      // Add event listener for when the request encounters an error
      request.addEventListener("error", function () {
        $(formElement).find('button').attr('disabled', false);
        $(formElement).find('.loading__spinner').addClass('hidden');
        $('[data-design-form-link]').find('.loading__spinner').addClass('hidden');
        console.error("An error occurred while submitting the form:", request.statusText);
      });
    
      request.open("POST", formElement.action);
      request.send(formData);
      e.preventDefault()
  })

  $('[data-email-cart]').submit(function(e){

      var formElement = this;
      var formData = new FormData(formElement);
      var request = new XMLHttpRequest();
    
      // Add event listener for when the request is completed
      request.addEventListener("load", function () {
        if (request.status >= 200 && request.status < 400) {
           $(formElement).after('<div class="sent-message">Your cart was successfully sent!</div>')
          gtag_report_conversion();
          fbq('track', 'Lead');
        } else {
    
        }
      });
    
      // Add event listener for when the request encounters an error
      request.addEventListener("error", function () {
        console.error("An error occurred while submitting the form:", request.statusText);
      });
    
      request.open("POST", formElement.action);
      request.send(formData);
      e.preventDefault()
  })

  $('[data-design-form-static] form').on('submit', function (e) {
    
    e.preventDefault();
    var hasError = false;

    $(this).find(".required-field input:not(.additinal-files), .required-field textarea").each(function () {
        if (!validateInput($(this))) {
          hasError = true;
        }
      });


    if (!hasError) {
        
        var $form = $(this);
        var formElement = $form[0];
        var formData = new FormData(formElement);
        var request = new XMLHttpRequest();

         $form.find('.loading__spinner').removeClass('hidden');
        
        // Add event listener for when the request is completed
        request.addEventListener("load", function () {
          if (request.status >= 200 && request.status < 400) {          
              $form.closest('[data-design-form-static]').hide().next().show()
              gtag_report_conversion();
              fbq('track', 'Lead');
          } else {
            $form.find('.loading__spinner').addClass('hidden');
          }
        });
      
        // Add event listener for when the request encounters an error
        request.addEventListener("error", function () {
          console.error("An error occurred while submitting the form:", request.statusText);
          $form.find('.loading__spinner').addClass('hidden');
        });
      
        request.open("POST", formElement.action);
        request.send(formData);
      }
  });
  //  Copy URL to clipboard
  $("body").on("click", ".icon-iconmonstr-link-thin", function () {
    var url = window.location.href;

    copyUrl(url);
    if (!$(".copyText").length) {
      $(this).after('<span class = "copyText"> Link copied </span>');
      setTimeout(() => {
        jQuery(".copyText").remove();
      }, 1500);
    }
  });
  selfBlur(jQuery);

  function selfBlur($) {
    $("body").on("click", function (e) {
      var _pop = $(".email-open .content");

      if (!_pop.is(e.target) && _pop.has(e.target).length === 0) {
        jQuery(".email-open").removeClass("active");
      }
      var _lightBox = $(".image-light-box .content");
      var _lightBox2 = $(".product-info__accordion-light-box .img");
      var _lightBox3 = $(".product-info__images-light-box .content");
      var _option = $(".option-select");
      var _lightBox4 = $(".kitchen-design-light-box .content");

      if (!_lightBox.is(e.target) && _lightBox.has(e.target).length === 0) {
        $(".image-light-box").removeClass("active");
      }
      if (!_lightBox2.is(e.target) && _lightBox2.has(e.target).length === 0) {
        $(".product-info__accordion-light-box").removeClass("active");
      }
      if (!_lightBox3.is(e.target) && _lightBox3.has(e.target).length === 0) {
        $(".product-info__images-light-box").removeClass("active");
      }
      if (!_option.is(e.target) && _option.has(e.target).length === 0) {
        $(".select-input").removeClass("active");
        $(".option-select ul").slideUp();
      }
      if($(e.target).is('.kitchen-design-light-box-close') || $(e.target).closest('.kitchen-design-light-box-close').length){
        $(".kitchen-design-light-box ").removeClass("active");  
      }
      if (!_lightBox4.is(e.target) && _lightBox4.has(e.target).length === 0) {
        $(".kitchen-design-light-box ").removeClass("active");  
        $('html, body').removeClass('overflow_hidden');
      }
    });
  }
}
function stickyNav() {
  var h2Elements = $(".faq-content .faq-items h2");
  var headerHeight = $(".header").innerHeight();
  h2Elements.each(function (index) {
    var html = $(this)
      .html()
      .replace(/[^\w]|_/g, "");

    $(this).attr("id", html);
    var $navLink = $(".faq-nav__links .faq-link").eq(index);
    $navLink.attr("href", "#" + html);
  });
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    var headerHeight = $(".header").innerHeight();
    $(".faq-nav__links .faq-link").each(function () {
      var $this = $(this);
      var top_H = $(this.hash).offset().top;
      if (top_H - headerHeight <= scrollTop) {
        $(".faq-nav__links .faq-link").removeClass("active");
        $this.addClass("active");
      }
    });
  });
  $(".faq-nav__links .faq-link").click(function () {
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - headerHeight + 1 }, 800);
  });

  if($(location.hash).length > 0){
    if(location.hash === '#submenu'){
      //$("html,body").animate({ scrollTop: $(location.hash).offset().top - headerHeight + 26 }, 0);
      
    }else{
      $("html,body").animate({ scrollTop: $(location.hash).offset().top - headerHeight + 1 }, 800);  
    }
    
  }
}
function file() {
  if ($("#drop-area").length) {
    const dropArea = document.getElementById("drop-area");
    // dropArea.addEventListener("dragover", function (e) {
    //   e.stopPropagation();
    //   e.preventDefault();
    //   e.dataTransfer.dropEffect = "copy";
    // });
    dropArea.addEventListener("drop", function (e) {
      // e.stopPropagation();
      // e.preventDefault();

      const files = e.dataTransfer.files;
      handleFiles(files);
    });

    // dropArea.addEventListener("click", function (e) {
    //   document.getElementById("file-upload").click();
    // });
    // document.getElementById("file-upload").addEventListener("change", function (e) {
    //   const files = e.target.files;
    //   handleFiles(files);
    // });
    function handleFiles(files) {
      const fileNames = Array.from(files)
        .map((file) => file.name)
        .join(", ");
      $(".file-name").append(fileNames);

     
    }
    $(".delete").click(function (e) {
      $(".file-name").text("");
      $('.file-upload').val('');
      $('.additinal-files').remove();
      e.stopPropagation();
    });
    $(document).on('change', '.file-upload', function() {
        var file_names = [];
      $('.file-upload').each(function() {
            Array.from($(this)[0].files).forEach(file => {
              file_names.push(file.name)
            })
      });
      $(".file-name").text(file_names.join(", "));
       $('.drag-box').append('<input name="q8_files[]" type="file" class="file-upload additinal-files" multiple>')
    })
  }
}
function appendFiles(){
  
}
function copyUrl(id) {
  jQuery("body").after("<input id='copyVal'></input>");
  var text = id;
  var input = document.getElementById("copyVal");
  input.value = text;
  input.select();
  input.setSelectionRange(0, input.value.length);
  document.execCommand("copy");
  jQuery("#copyVal").remove();
}

function splitDataAttributes(element, attributes) {
  let results = [];
  attributes.forEach((attr) => {
    let dataValue = element.attr(attr);
    if (dataValue) {
      results.push(...dataValue.split(",").map((item) => item.trim()));
    }
  });
  return results;
}

function filterInput() {
  console.log('filter init')
  let shippingArray = [];
  let styleArray = [];
  let colorArray = [];
  let typeArray = [];

  const originalCards = $(".filter__cards .card").toArray();
  var sum = $(".filter__cards .card").length;
  $(".styles-count,.filter-reset span:first-child").text(sum + " styles");
  updateCounts();
  $('.filter__sorts-items input[type="checkbox"]').each(function () {
    var inputValue = $(this).next().text().trim();
    let count = 0;

    $(".filter__cards .card").each(function () {
      let attributes = ["data-shipping", "data-style", "data-color", "data-finish_type"];
      let cardArray = splitDataAttributes($(this), attributes);

      if (cardArray.includes(inputValue)) {
        count++;
      }
    });
    $(this).siblings(".num").text(count);
    if(count == "0") { 
      $(this).closest(".check-item").css('display', 'none');
    } else {
      $(this).closest(".check-item").css('display', 'block');
    }
  });

  $('.filter__sorts-items input[type="checkbox"]').change(function () {
    let elementToInsert = $(this).next().text().trim();
    let titleText = $(this).closest(".filter__sorts-item").find("h3").text().trim();
    let targetArray;
    if (titleText === "SHIPPING") {
      targetArray = shippingArray;
    } else if (titleText === "STYLE") {
      targetArray = styleArray;
    } else if (titleText === "COLOR") {
      targetArray = colorArray;
    } else if (titleText === "FINISH TYPE") {
      targetArray = typeArray;
    }

    if ($(this).is(":checked")) {
      if (!targetArray.includes(elementToInsert)) {
        targetArray.push(elementToInsert);
      }
    } else {
      let index = targetArray.indexOf(elementToInsert);
      if (index !== -1) {
        targetArray.splice(index, 1);
      }
    }
    filterCards();
    updateCounts();
    var num = $(".filter__cards .card").length - $(".filter__cards .card:hidden").length;
    $(".styles-count,.filter-reset span:first-child").text(num + " styles");
    if (history.pushState) {
        var baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        var newurl = baseUrl;
        if(colorArray.length){
          newurl = baseUrl + '?' + 'color=' + colorArray.join(',');
        }
        window.history.pushState({path:newurl},'',newurl);
    }
    //location.hash = ('color=' + colorArray.join(','))
  });

  $(".reset").click(function () {
    var sum = $(".filter__cards .card").length;
    $(".styles-count,.filter-reset span:first-child").text(sum + " styles");
    $(".filter__sorts-items input").prop("checked", false);
    $(".filter__cards .card").removeClass("sorted");
    updateCounts();
  });

  function filterCards() {
    // Determine if there are any cards with the 'js-high' class
    const highPriorityCards = $(".filter__cards .card.js-high");

    // Select the cards to filter
    const cardsToFilter = highPriorityCards.length > 0 ? highPriorityCards : $(".filter__cards .card");

    cardsToFilter.each(function () {
      const data = {
        shipping: $(this).attr("data-shipping").split(",").map((s) => s.trim()),
        style: $(this).attr("data-style").split(",").map((s) => s.trim()),
        color: $(this).attr("data-color").split(",").map((s) => s.trim()),
        type: $(this).attr("data-finish_type").split(",").map((s) => s.trim())
      };

      const isVisible = (shippingArray.length === 0 || shippingArray.some((r) => data.shipping.includes(r))) &&
                        (styleArray.length === 0 || styleArray.some((r) => data.style.includes(r))) &&
                        (colorArray.length === 0 || colorArray.some((r) => data.color.includes(r))) &&
                        (typeArray.length === 0 || typeArray.some((r) => data.type.includes(r)));
      console.log('isVisible', isVisible)
      $(this).toggle(isVisible);
    });

    // Hide the cards that are not part of the selected set
    const otherCards = highPriorityCards.length > 0 ? $(".filter__cards .card").not(".js-high") : $();
    otherCards.hide();
  }

  function updateCounts() {
    $('.filter__sorts-items input[type="checkbox"]').each(function () {
      var inputValue = $(this).next().text().trim();
      var titleText = $(this).closest(".filter__sorts-item").find("h3").text().trim();
      let count = 0;

      const highPriorityCards = $(".filter__cards .card.js-high");
      const cardsToCount = highPriorityCards.length > 0 ? highPriorityCards : $(".filter__cards .card:visible");
      if (titleText !== "COLOR") {
        cardsToCount.each(function () {
          let attributes = ["data-shipping", "data-style", "data-color", "data-finish_type"];
          let cardArray = splitDataAttributes($(this), attributes);

          if (cardArray.includes(inputValue)) {
            count++;
          }
         
        });
        
        $(this).siblings(".num").text(count);
        // if(count == "0") { 
        //   $(this).closest(".check-item").css('display', 'none');
        // } else {
        //   $(this).closest(".check-item").css('display', 'block');
        // }
      } else {
        $(this).siblings(".num").text($(this).siblings(".num").text());
      }
     
    });
  }

  $('.filter__sorts-items input[type="radio"]').change(function () {
    let elementToInsert = $(this).next().text().trim();
    let cards = $(".filter__cards .card").toArray();
    $(".filter__cards .card").addClass("sorted");
    if ($(this).is(":checked")) {
      cards.sort((a, b) => {
        const priceA = parseFloat($(a).attr("data-price"));
        const priceB = parseFloat($(b).attr("data-price"));
        return elementToInsert === "Price: Low to High" ? priceA - priceB : priceB - priceA;
      });
      $(".filter__cards").empty().append(cards);
    }
  });

  // Shop by Color
  function checkColorCheckbox(colorName) {
    var $checkbox = $('.filter__sorts-items input[name="' + colorName + '"]');
    if ($checkbox.length) {
        $checkbox.prop('checked', true).change();
    }
  }

  // Handling color item clicks
  $('.color-and-collection .color-items .item').click(function() {
    var color = $(this).text().trim();
    checkColorCheckbox(color);
    var headerHeight = $('.header').outerHeight();
    if ($('.filter-sec').length ) {
      var filterOffset = $('.filter-sec').offset().top - headerHeight;
        $('html, body').animate({
          scrollTop: filterOffset
        }, 800);
    }
  });

  $('.color-and-collection .collection-items .item').click(function () {
    var title = $(this).find(">span").text().trim().toLowerCase();
    var regexPattern = '\\b' + title + '\\b'; // Create a pattern for whole word match
    var regex = new RegExp(regexPattern, 'i');

    $('.filter__cards .card').css('display', 'none'); // Hide all cards initially
    $('.filter__cards .card').each(function () {
        var titleEle = $(this).find('h3').text().trim().toLowerCase();
        if (regex.test(titleEle)) {
            $(this).css('display', 'flex').addClass('js-high'); // Only show this card if it matches
        }
    });
    filterCards();  // Reapply filter after showing matching cards
    updateCounts(); // Update counts after filtering
    var headerHeight = $('.header').outerHeight();
    if ($('.filter-sec').length ) {
      var filterOffset = $('.filter-sec').offset().top - headerHeight;
        $('html, body').animate({
          scrollTop: filterOffset
        }, 800);
    }
  });
  
  window.onload = function() {
    keywords = decodeURIComponent(window.location.href.split('=')[1]);
    keywords = keywords.split(',');
   
    keywords.forEach(function(keyword){
      $('.filter__sorts-items input[name="'+keyword+'"]').prop('checked', true).change();  
    })
    filterCards();  // Reapply filter after showing matching cards
    updateCounts(); // Update counts after filtering
  
    var isScroll =  window.location.href.split('?')[1] ? true: false;
    var headerHeight = $('.header').outerHeight();
    if ($('.filter-sec').length ) {
      var filterOffset = $('.filter-sec').offset().top - headerHeight;
      if (isScroll) {
        $('html, body').animate({
          scrollTop: filterOffset
        }, 800);
      }
    }
  
  };
}


// options select 
// compare objects
function isSubset(subObj, obj) {
  return Object.keys(subObj).every(key => obj.hasOwnProperty(key) && obj[key] === subObj[key]);
}
// get attributes and transmit to form
function updateUI(parentItem, data) {
  parentItem.find('.add-to-cart input[name="id"]').val(data.id);
  if(data.comparePrice){
    parentItem.find('.price-item--sale').text("$" + data.price);
    parentItem.find('.price-item--regular').text("$" + data.comparePrice);
  }else{
    parentItem.find('.price-item--regular').text("$" + data.price);
  }
  

  if (data.discount === "100") {
      parentItem.find('.discount-tag').hide();
      parentItem.find('.price .price__sale .price-item--regular').hide();
  } else {
    parentItem.find('.discount-tag span').text("Save " +data.discount+"%" );
  }
  if (data.soldout === "true") {
      parentItem.find('.product-form__submit span').text('Sold Out');
  }
}
// main function 
function optionSubmit() {
  
  
  
  $(".cart-item__details-optional .option input").change(function () {

      let dataArray = [];
      const $parentItem = $(this).closest('.cart-item');
      const $varsValueDivs = $parentItem.find(".vars-value div");
      
      $varsValueDivs.each(function () {
          var attrs = {};
          $.each(this.attributes, function () {
            if (this.specified) {
              attrs[this.name] = this.value;
            }
          });
          dataArray.push(attrs);
      });

      const valueArray = [];
      const $inputs = $parentItem.find(".cart-item__details-optional .option");
      $inputs.each(function () {
          const value = $(this).find(".select-input span").data('value');
          const data_name = "data-" + $(this).find(".option-select").attr("data-name");
          if (data_name) {
              valueArray.push({ [data_name]: value });
          }
      });
      
      $varsValueDivs.each(function (index) {
          const allMatch = valueArray.every(valueObject => {
            return isSubset(valueObject, dataArray[index])
          });
  
          if (allMatch) {
              const data = {
                  id: $(this).attr('data-id'),
                  soldout: $(this).attr('data-soldout'),
                  price: $(this).attr('data-price'),
                  comparePrice: $(this).attr('data-compare_at_price'),
                  discount: $(this).attr('data-discount')
              };
              updateUI($parentItem, data);
          }
      });
  });
  
  }

function haveCommonElement(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item));
}
function stickyProductLists() {
  if ($('.product-cart__tags').length > 0) {
    $('.product-cart__tags').before('<div class ="js-hidden"></div>');
    
    var bottomHeaderHeight = $('.header__navigation').outerHeight();
    var topHeaderHeight = $('.header .header__top-bar').outerHeight();
    var headerHeight = bottomHeaderHeight + topHeaderHeight;
    var scrollTop = $(window).scrollTop();
    var eleTop = $('.js-hidden').offset().top;
    var eleHeight = $('.product-cart__tags').innerHeight();
    var footerOffsetTop = $('.order-your-kitchen.bg-yellow').offset().top;
    var width = $('.product-cart-lists').width();
    if (
      scrollTop + headerHeight > eleTop 
      && scrollTop + headerHeight < footerOffsetTop - eleHeight
    ) {
      $('.product-cart__tags').addClass('sticky').css({'top': headerHeight , "width": width });
      $('.js-hidden').height(eleHeight);
    } else {
      $('.product-cart__tags').removeClass('sticky').css('width',"auto");
      $('.js-hidden').height('0');
    }

    $(window).scroll(function () {
      var bottomHeaderHeight = $('.header__navigation').outerHeight();
    var topHeaderHeight = $('.header .header__top-bar').outerHeight();
    var headerHeight = bottomHeaderHeight + topHeaderHeight;
      var scrollTop = $(window).scrollTop();
      var eleHeight = $('.product-cart__tags').innerHeight();
      var eleTop = $('.js-hidden').offset().top;
      var width = $('.product-cart-lists').width();
      var footerOffsetTop = $('.order-your-kitchen.bg-yellow').offset().top;
      if (scrollTop + headerHeight > eleTop  && scrollTop + headerHeight < footerOffsetTop - eleHeight ) {
        $('.product-cart__tags').addClass('sticky').css({'top': headerHeight , "width": width });
        $('.js-hidden').height(eleHeight);
      } else {
        $('.product-cart-lists .product-cart__tags .tags .tag').removeClass('shrink')
        $('.product-cart__tags').removeClass('sticky').css('width',"auto");
        $('.js-hidden').height('0');
      }
    });

    $(window).resize(function () { 
      var width = $('.product-cart-lists').width();
      $('.product-cart__tags').css('width', width);
     })
  }
}


function giveMore(button, targetUl, showNumber, loadNumber, speed) {
  var list = showNumber;
  var row = jQuery(targetUl);
  var sum = row.find(">.item,.card").hide().length;

  if (sum > list) {
    row.find(".item:lt(" + list + ")").show();
  }

  $(button).on("click", function () {

    if ($(this).hasClass('view-more')) {
      $(this).find('span').eq(0).text('View less');
      list += sum;
      row.find(".item:lt(" + list + ")").slideDown(speed ? speed : 400);

      if($(this).hasClass('active')){

        $(this).find('span').eq(0).text('View more'); 

        row.find(".item:gt(0)").slideUp(speed ? speed : 400);

        $(this).removeClass('active');

      } else {

        $(this).addClass('active');

      }
   
    } else {
      undefined;
      list += sum;
      row.find(".item:lt(" + list + ")").slideDown(speed ? speed : 400);
    }

  });

}
var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  // $('.banner__text-content >*').addClass('wowo fadeInUp');
  wowo();

  swiper();
  video();
  hoverSwitch();
  click();
  stickyNav();
  file();
  filterInput();
  resizeWindow();
  //cookie();
  optionSubmit();
  stickyProductLists();
  //giveMore(".loadmore", ".filter__cards", 6);
  if ($(window).width() < 991) {
    giveMore(".view-more", ".banner__text-items .items", 1);
    $('.share-cart').appendTo('.cart-content-js')
  }
  jQuery(window).scroll(function () {
    wowo();
  });
  jQuery(window).resize(function () {
    // if ($(window).width() < 991) {
    //   giveMore(".view-more", ".banner__text-items .items", 1);
    // }
  });

  var searchParams = new URLSearchParams(location.search);
  var trackingFields = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ]
  trackingFields.forEach(p => {

    var track = searchParams.get(p) ? searchParams.get(p) : sessionStorage[p];
    
    if(track){
      sessionStorage[p] = track;
      document.querySelectorAll('[data-name="'+p+'"]').forEach(function(elm){
        if(!elm.value){
          elm.value = track
        }
      })
    }
  })

  document.querySelectorAll('[data-name="token"]').forEach(function(elm){
        if(!elm.value){
          let cc = Object.fromEntries(document.cookie.split('; ').map(c => {
              const [ key, ...v ] = c.split('=');
              return [ key, v.join('=') ];
          }));
          elm.value = JSON.stringify(cc);
        }
      })
  
  if(searchParams.get('email') && $(".kitchen-design-light-box").length){

      $('.design-form-link').hide().prev().hide();
      $(".kitchen-design-light-box").addClass("active");

      const formData = {
        name: searchParams.get('name'),
        phone: searchParams.get('phoneNumber'),
        email: searchParams.get('email'),
        message: searchParams.get('message'),
      };
    
      Object.keys(formData).forEach((key) => {
        $('[data-design-form] [data-name="'+key+'"]').val(formData[key]);
      });
      $('.form-field-name').text(formData.name);
    
  }

  Fancybox.bind()
}).on('click', '[data-load-videos]', function(){
  $('[data-video-embed] iframe:not(.loaded)').each(function(){
      $(this).attr('src', $(this).data('src')).addClass('loaded')
    })
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    wowo();
    swiper();
  });
  document.addEventListener('shopify:section:reorder', () => {
    wowo();
    swiper();
  });
}
